<template>
  <aha-modal @hide="hide()" :title="title_DeleteFolder">
    <div :inner-html.prop="modalContent" />
    <div class="pl-4 mt-2 overflow-auto max-h-24" v-if="folder.presentations.length">
      <ul class="list-disc">
        <li
          v-for="(presn, presnIndex) in folder.presentations"
          :key="presnIndex"
        >
          {{ presn.name }}
        </li>
      </ul>
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isDeletingFolder"
        @click="handleDeleteFolder()"
        icon-name="delete"
        :submitting="isDeletingFolder"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isDeletingFolder" />
        {{ $i18nPresenter.t("Remove") }}
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'

// api
import FolderApi from '@/api/folder'

// constants
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant'

// utils
import utils from '@/util'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDeletingFolder: false,
      modalContent: '',
      title_DeleteFolder: this.$i18nPresenter.t('Remove confirmation'),
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.generateModalContent()
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
      'setErrorOnInternalServerAction',
    ]),
    generateModalContent() {
      const mainContent =
      `Are you sure you want to remove this folder
      <span class="font-bold break-words"> ${this.folder.folderName}</span>?
      `
      let moreContent = '<p>It contains no presentation.</p>'
      const numberOfPresn = this.folder.presentations.length
      if (numberOfPresn === 1) {
        moreContent = '<p>It contains 1 presentation:</p>'
      } else if (numberOfPresn > 1) {
        moreContent = `<p>It contains ${numberOfPresn} presentations:</p>`
      }
      this.modalContent = mainContent + moreContent
    },
    handlAfterCallAPIDeleteFolder(folderId) {
      utils.showToastSuccess(`${this.$i18nPresenter.t('Deleted folder')} "${this.folder.folderName}"`)
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Succeeded', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        folderId: folderId || null,
        teamId: this.$store.state.currentAccount.id,
      })
      const index = this.folders.findIndex((folder) => {
        return folder.folderId === this.folder.folderId
      })
      this.folders.splice(index, 1)
      this.setFoldersAction(this.folders)
    },
    async handleDeleteFolder() {
      this.isDeletingFolder = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Submit')
      try {
        await FolderApi.removeFolderById(this.folder.folderId)
        this.handlAfterCallAPIDeleteFolder(this.folder.folderId)
      } catch {
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Failed')
        this.setErrorOnInternalServerAction(`Cannot delete folder ${this.folder.folderName}`)
      } finally {
        this.isDeletingFolder = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
